import request from './adminRequest'

export const appliedJobApi = {
  listAppliedJob (params) {
    return request.get('/appliedJobs/', { params: params })
  },
  getAppliedJob (id) {
    return request.get('/appliedJobs/' + id)
  },
  processAppliedJob (id, data) {
    return request.put('/appliedJobs/' + id, data)
  },
  deleteAppliedJob (id) {
    return request.delete('/appliedJobs/' + id)
  },

}
export default appliedJobApi
